import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useParams } from 'react-router-dom';

import APModal from 'components/Modal/APModal';
import EmailEditForm from './EmailEditForm';
import EmailPreviewForm from './EmailPreviewForm';

import './styles.scss';

const NoteShareModal = ({ open, onClose, note }) => {
  const { projectId } = useParams();
  const [preview, togglePreview] = useState(false);
  const [emailFormData, setEmailFormData] = useState(null);

  const dismiss = () => onClose();

  return (
    <APModal
      open={open}
      title={preview ? '' : 'Share your note.'}
      name="share-note"
      className={clsx('note_share_form__container')}
      onClose={preview ? () => togglePreview(false) : onClose}
      shouldCloseOnOverlayClick={false}
    >
      {!preview ? (
        <EmailEditForm
          projectId={projectId}
          notes={[note]}
          formData={emailFormData}
          onPreview={(form) => {
            setEmailFormData(form);
            togglePreview(true);
          }}
          dismiss={dismiss}
          showTemplates
        />
      ) : (
        <EmailPreviewForm
          formData={emailFormData}
          onBack={() => togglePreview(false)}
        />
      )}
    </APModal>
  );
};

NoteShareModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  note: PropTypes.object,
};

NoteShareModal.defaultProps = {};

export default NoteShareModal;
